import api from '@/apiManager/apiManager'

export const getEmployees = data => {
  const url = `/corporate-admin/employees/list?limit=${data.limit}&offset=${data.offset}&key=${data.key}&status=ACTIVE`
  return api('get', url, '', 'base')
}

// Every community member, joined or still pending — the user-search modal lists
// them before anything is typed. Omitting `status` means "any status".
export const getCommunityMembers = data => {
  const key = data.key ? `&key=${encodeURIComponent(data.key)}` : ''
  const url = `/corporate-admin/employees/list?limit=${data.limit}&offset=${data.offset}${key}`
  return api('get', url, '', 'base')
}

export const getRequestedEmployees = data => {
  const url = `/corporate-admin/employees/list?limit=${data.limit}&offset=${data.offset}&key=${data.key}&status=PENDING`
  return api('get', url, '', 'base')
}

export const addRequestedEmployees = data => {
  const url = '/corporate-admin/employees/accept-request'
  return api('post', url, data, 'base')
}

export const rejectRequestedEmployees = data => {
  const url = '/corporate-admin/employees/accept-request'
  return api('post', url, data, 'base')
}
export const getSlugUrl = (data) => {
  const url = `/corporate-admin/employees/corporate-url${data?.uId ? '?uId='+data.uId: ''}`
  return api('get', url, '', 'base')
}

export const addEmployee = data => {
  const url = '/corporate-admin/employees/add'
  return api('post', url, data, 'base')
}

export const searchEmployees = query => {
  const url = `/corporate-admin/employees/search?query=${query}`
  return api('get', url, '', 'base')
}

export const deleteEmployee = (id, status) => {
  const url = `/corporate-admin/employees/${id}?status=${status}`
  return api('delete', url, '', 'base')
}
export const getCorporateUrl = data => {
  const url = '/corporate-admin/employees/corporate-url-exist'
  return api('post', url, data, 'base')
}
export const updateCorporateUrl = data => {
  const url = '/corporate-admin/employees/corporate-url'
  return api('patch', url, data, 'base')
}
export const getInspiredEmployee = () => {
  const url = '/corporate-admin/employees/most-inspiring-employees?offset=0&limit=100000'
  return api('get', url, '', 'base')
}
export const getInvitationAnalytics = () => {
  const url = '/corporate-admin/employees/employee-invitation-analytics'
  return api('get', url, '', 'base')
}
export const getCSVEmployeeParticipants = (data) => {
  const url = `/corporate-admin/employees/list/export/csv?limit=${data.limit}&offset=0&status=ACTIVE`
  return api('get', url, '', 'base')
}

